
import GeneralButton from "../common/GeneralButton";
import { TiPlus } from "react-icons/ti";
import ProgressLine from "./ProgressLine";
import { useStep } from "../contexts/SubscriptionContext";
import { useNavigate } from "react-router-dom";

const TopStepsStatus = ({ rightText = "Schools & Nurseries?", url }) => {
  const { activeStep } = useStep();
  const navigate = useNavigate()
  return (
    <div className="grid grid-cols-1 lg:grid-cols-[1.5fr_1fr] xl:grid-cols-[2fr_1fr] bg-[#DEE2DD]/50 rounded-[15px] lg:h-[141px] gap-10 px-6 lg:px-8 2.5xl:px-12 py-4 lg:py-6">
      <div className={`${rightText?"-mt-5 lg:mt-0":"py-5"} order-2 lg:order-1 max-w-[1001px] flex  items-center justify-start  lg:mt-0`}>
        <ProgressLine active={activeStep} total={6} />
      </div>
      {rightText && (
        <div className="order-1 lg:order-2 flex flex-col items-end justify-center">
          <p className="text-24pt xl:text-32pt text-secondary mb-1">
            {rightText}
          </p>
          <GeneralButton
            text={"Click here"}
            textColor="#ccc"
            onClick={()=>navigate(`${url}`)}
            icon={<TiPlus size={24} className="ms-4" />}
            className="text-18pt xl:text-24pt"
          />
        </div>
      )}
    </div>
  );
};

export default TopStepsStatus;
